module.exports = __webpack_public_path__ + "img/Daniel.e9623541.png";